import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { formatDisplayValue, toFixedSafe } from '../../lib/styles/perttierNumber';

const StructureList = ({ conveyors, loading, error, project, ownProject, onEditStructure }) => {
    if (error) {
        return <StructureListBlock>에러가 발생했습니다.</StructureListBlock>;
    }
    if (!conveyors) {
        return <StructureListBlock>항목이 없습니다.</StructureListBlock>;
    }

    return (
        <StructureListBlock>
            <Content>
                <Caption>
                    <h1>Structure List</h1>
                    <span>(Unit: kg)</span>
                </Caption>
                <Table>
                    <thead>
                        <tr>
                            <th className="title">BC ID.</th>
                            <th className="info-window">Girder</th>
                            <th className="info-window">PC Panel</th>
                            <th className="info-window">Gallery</th>
                            <th className="info-window">Trestle</th>
                            <th className="info-window">Stringer</th>
                            <th className="info-window">Walkway</th>
                            <th className="info-window">
                                Decking
                                <br />
                                Plate
                            </th>
                            <th className="info-window">SideCover</th>
                            <th className="info-window">
                                Skirt
                                <br />
                                -board
                            </th>
                            <th className="info-window">Takeup</th>
                            <th className="info-window">
                                Pulley
                                <br /> Frame
                            </th>
                            <th className="info-window">
                                Common
                                <br /> Bed
                            </th>
                            <th className="info-window">Chute</th>
                            <th className="info-window">
                                Chute
                                <br />
                                Damper
                            </th>
                            <th className="info-window">
                                Chute
                                <br />
                                Liner
                            </th>
                            <th className="info-window">
                                Shuttle
                                <br />
                                Frame
                            </th>
                            <th className="info-window">
                                Tripper
                                <br />
                                Frame
                            </th>
                            <th className="info-window">
                                Wheel
                                <br />
                                Ass'y
                            </th>
                            <th className="info-window">Rail</th>
                            <th className="info-window">
                                Over-
                                <br />
                                bridge
                            </th>
                            <th className="info-window">
                                Internal
                                <br />
                                Belt
                                <br />
                                Cleaner
                            </th>
                            <th className="info-window">
                                Safety
                                <br />
                                Cover
                            </th>
                            <th className="info-window">
                                Anchor
                                <br />
                                Bolt
                            </th>
                            <th className="info-window">Total</th>
                            <th className="btn-area"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {conveyors.map((conveyor) => {
                            const {
                                _id: id,
                                title,
                                body: { structure },
                            } = conveyor;
                            return (
                                <tr key={id}>
                                    <td className="title">{title}</td>
                                    {!structure && (
                                        <>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <ActionButton>
                                                    {ownProject && (
                                                        <StyledButton onClick={() => onEditStructure(conveyor)}>
                                                            Edit
                                                        </StyledButton>
                                                    )}
                                                </ActionButton>
                                            </td>
                                        </>
                                    )}
                                    {structure && !structure.summary && (
                                        <>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <ActionButton>
                                                    {ownProject && (
                                                        <StyledButton onClick={() => onEditStructure(conveyor)}>
                                                            Edit
                                                        </StyledButton>
                                                    )}
                                                </ActionButton>
                                            </td>
                                        </>
                                    )}
                                    {structure && structure.summary && (
                                        <>
                                            <td>{formatDisplayValue(structure.summary.girder?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.pcPanel?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.gallery?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.trestle?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.stringer?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.walkway?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.deckingPlate?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.sideCover?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.skirtboard?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.takeup?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.pulleyFrame?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.commonBed?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.chute?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.chuteDamper?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.chuteLiner?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.shuttle?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.tripper?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.wheelAssy?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.rail?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.overbridge?.totalWeight)}</td>
                                            <td>
                                                {formatDisplayValue(structure.summary.internalBeltCleaner?.totalWeight)}
                                            </td>
                                            <td>{formatDisplayValue(structure.summary.safetyCover?.totalWeight)}</td>
                                            <td>{formatDisplayValue(structure.summary.anchorBolt?.totalWeight)}</td>
                                            <td>{formatDisplayValue(conveyorWeightTotal(structure.summary))}</td>
                                            <td>
                                                <ActionButton>
                                                    {ownProject && (
                                                        <StyledButton onClick={() => onEditStructure(conveyor)}>
                                                            Edit
                                                        </StyledButton>
                                                    )}
                                                </ActionButton>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                    {/* <tbody>
                        {conveyors.map(({ _id, title, body: { structure }}) => 
                            <tr key={_id}>
                                <td className="title">{title || 'unknown'}</td>
                                {structure && structure.summary ? (
                                    <>
                                        {Object.entries(structure.summary).map(([key, value]) => (
                                            <td key={key}>{value.totalWeight || 0}</td>
                                        ))}
                                        <td>{conveyorWeightTotal(structure.summary)}</td>
                                    </>
                                ) : (
                                    <>
                                        <td colSpan={13}><Link to=""></Link></td>
                                    </>
                                )}
                            </tr>
                        )}
                    </tbody> */}
                    <tfoot>
                        <tr>
                            <td className="title">Total</td>
                            <td>{itemWeightTotal(conveyors, 'girder')}</td>
                            <td>{itemWeightTotal(conveyors, 'pcPanel')}</td>
                            <td>{itemWeightTotal(conveyors, 'gallery')}</td>
                            <td>{itemWeightTotal(conveyors, 'trestle')}</td>
                            <td>{itemWeightTotal(conveyors, 'stringer')}</td>
                            <td>{itemWeightTotal(conveyors, 'walkway')}</td>
                            <td>{itemWeightTotal(conveyors, 'deckingPlate')}</td>
                            <td>{itemWeightTotal(conveyors, 'sideCover')}</td>
                            <td>{itemWeightTotal(conveyors, 'skirtboard')}</td>
                            <td>{itemWeightTotal(conveyors, 'takeup')}</td>
                            <td>{itemWeightTotal(conveyors, 'pulleyFrame')}</td>
                            <td>{itemWeightTotal(conveyors, 'commonBed')}</td>
                            <td>{itemWeightTotal(conveyors, 'chute')}</td>
                            <td>{itemWeightTotal(conveyors, 'chuteDamper')}</td>
                            <td>{itemWeightTotal(conveyors, 'chuteLiner')}</td>
                            <td>{itemWeightTotal(conveyors, 'shuttle')}</td>
                            <td>{itemWeightTotal(conveyors, 'tripper')}</td>
                            <td>{itemWeightTotal(conveyors, 'wheelAssy')}</td>
                            <td>{itemWeightTotal(conveyors, 'rail')}</td>
                            <td>{itemWeightTotal(conveyors, 'overbridge')}</td>
                            <td>{itemWeightTotal(conveyors, 'internalBeltCleaner')}</td>
                            <td>{itemWeightTotal(conveyors, 'safetyCover')}</td>
                            <td>{itemWeightTotal(conveyors, 'anchorBolt')}</td>
                            <td>{grandTotal(conveyors)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </Table>
            </Content>
        </StructureListBlock>
    );
};

export default StructureList;

/* =================   Styles   ================== */
const StructureListBlock = styled.div`
    display: flex;
    img {
        width: 100%;
    }
`;

const Content = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Caption = styled.div`
    display: flex;
    justify-content: space-between;
    h1 {
        font-size: 1.125rem;
        margin: 0;
        margin-bottom: 1rem;
    }
    span {
        font-size: 0.9rem;
    }
`;

const Table = styled.table`
    //overflow-x: auto;   // 테이블을 감싸는 요소에 적용해야 한다.

    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
    text-align: center;
    thead tr th {
        font-weight: 500;
        padding: 0.5rem 0.25rem;
        background: ${palette.gray[2]};
        border-bottom: 2px solid ${palette.gray[4]};
    }
    tbody tr {
        &:nth-child(even) {
            background: ${palette.gray[2]};
        }
    }
    tbody tr td {
        height: 3rem;
        padding: 0.5rem 0.25rem;
    }
    tfoot {
        background: ${palette.gray[2]};
        // text-align: right;
        font-weight: 500;
        border-top: 2px solid ${palette.gray[4]};
    }
    tfoot tr td {
        height: 3rem;
        padding: 0.5rem 0.5rem;
    }
    .title {
        text-align: center;
        min-width: 80px;
    }
    .belt-width {
        min-width: 100px;
    }
    .info-window {
        min-width: 100px;
    }
    .weight {
        min-width: 100px;
    }
    .btn-area {
        min-width: 70px;
    }
`;

const ActionButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 1rem;
    // margin-bottom: 2rem;
`;

const StyledButton = styled.button`
    padding: 0.125rem 0.25rem;
    border-radius: 4px;
    border: none;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.85rem;
    font-weight: 550;
    text-align: center;
    border: 1px solid transparent;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        cursor: pointer;
        transition: 0.3s;
    }
`;

// 컨베이어별로 전체 중량을 계산한다.
export const conveyorWeightTotal = (summary) => {
    // console.log('conveyorItemWeights : ', conveyorItemWeights);
    if (!summary || !Object.keys(summary)) return 0;

    let total = 0;
    for (let key in summary) {
        // console.log('key : ', key);
        total += summary[key]?.totalWeight;
    }
    return total;
};

// const keyArray = [
//     'girder',
//     'gallery',
//     'trestle',
//     'stringer',
//     'walkway',
//     'skirtboard',
//     'takeup',
//     'pulleyFrame',
//     'commonBed',
//     'chute',
//     'accessory',
//     'etc',
// ];

// export const itemWeightTotal = (conveyors) => {
//     const itemWeight = {};

//     for (let key in keyArray) {
//         let sum = 0;
//         conveyors.forEach(conveyor => {
//             const { structure: { summary } } = conveyor.body;
//             sum += summary[key]
//         })
//         itemWeight[key] = sum;
//     }

//     return itemWeight;
// }

export const itemWeightTotal = (conveyors, key) => {
    if (!conveyors) return;
    let sum = 0;
    conveyors.forEach((conveyor) => {
        const { structure } = conveyor.body;
        if (!structure || !structure.summary) {
            return 0;
        }
        sum += structure.summary[key] ? structure.summary[key].totalWeight : 0;
    });
    return sum;
};

export const grandTotal = (conveyors) => {
    let grandTotal = 0;
    conveyors.forEach((conveyor) => {
        let subTotal = 0;
        const { structure } = conveyor.body;
        if (!structure || !structure.summary) {
            return 0;
        }
        for (let key in structure.summary) {
            subTotal += structure.summary[key] ? structure.summary[key].totalWeight : 0;
        }
        grandTotal += subTotal;
    });
    return grandTotal;
};
